module.exports = __webpack_public_path__ + "img/4-道具中心-02.d9e4dac7.png";